import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Col, Spinner, Card, Button } from "react-bootstrap";
import { API, username } from "../../API";
import "./ShopPage.css"; // Custom styles
import ShopBanner from "./ShopBanner";
import NavBar from "../Navbar";
import { Helmet } from "react-helmet-async";

const ShopPage = ({ banner }) => {
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("All");
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [productsPerPage] = useState(12);

    // const getToken = () => {
    //     const authData = localStorage.getItem("auth");
    //     if (authData) {
    //         try {
    //             const parsedData = JSON.parse(authData);
    //             return parsedData.token;
    //         } catch (error) {
    //             console.error("Error parsing auth data:", error);
    //             return null;
    //         }
    //     }
    //     return null;
    // };

    const fetchProducts = async () => {
        // const token = getToken();
        // if (!token) {
        //     console.error("No authentication token found!");
        //     return;
        // }

        try {
            setLoading(true);
            const response = await axios.get(`${API}/products/`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",

                },
            });

            const productData = response.data.data || [];
            const categories = [
                "All",
                ...new Set(productData.map((product) => product.category?.category || "Uncategorized")),
            ];
            setProducts(productData);
            console.log('ffffffdbbdbdbffff', response.data)

            setFilteredProducts(productData);
            setCategories(categories);
        } catch (error) {
            console.error("Error fetching products:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    const handleFilter = (category) => {
        setSelectedCategory(category);
        if (category === "All") {
            setFilteredProducts(products);
        } else {
            setFilteredProducts(products.filter((product) => product.category?.category === category));
        }
        setCurrentPage(1); // Reset to the first page when filter changes
    };

    const indexOfLastProduct = currentPage * productsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
    const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);
    console.log('ffffffffff', currentProducts)

    const totalPages = Math.ceil(filteredProducts.length / productsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <>
            <Helmet>
                <title>Shop - OTT Channel | Exclusive Products</title>
                <meta
                    name="description"
                    content="Discover the best products, exclusive TV shows, and movies on our OTT Channel. Shop now for a premium streaming experience."
                />
                <meta
                    name="keywords"
                    content="Shop, Streaming Products, TV Shows, Movies, OTT Channel"
                />
            </Helmet>

            <div className="px-3 px-md-5 px-lg-7">

                <NavBar />
                {/* <h2 className="text-center mb-4 mt-5 text-white fw-semibold">Shop</h2> */}
                <ShopBanner banner={banner} />

                <h3 className="text-center mb-4 text-white fw-semibold">Categories</h3>
                <Row className="mb-4">
                    <Col xs={12} className="d-flex justify-content-center flex-wrap">
                        {categories.map((category) => (
                            <button
                                key={category}
                                className={`category-btn ${selectedCategory === category ? "active" : ""}`}
                                onClick={() => handleFilter(category)}
                            >
                                {category}
                            </button>
                        ))}
                    </Col>
                </Row>

                {loading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "50vh" }}>
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    <Row>
                        {currentProducts.length > 0 ? (
                            currentProducts.map((product) => (
                                <Col key={product.id} xs={12} sm={6} md={4} lg={3} className="mb-4">
                                    <Card className="product-card h-100 shadow-sm">
                                        <div className="image-wrapper">
                                            <Card.Img
                                                variant="top"
                                                src={product.image || "/placeholder.jpg"}
                                                alt={product.title || "Product Image"}
                                            />
                                        </div>
                                        <Card.Body className="d-flex flex-column">
                                            <Card.Title className="text-truncate">
                                                {product.title || "Untitled"}
                                            </Card.Title>
                                            <div className="price-container">
                                                <span className="original-price">{product.sale_price}</span>
                                                {product.sale_price && (
                                                    <span className="sale-price">{product.sale_price}</span>
                                                )}
                                            </div>
                                            <Button variant="primary" className="mt-auto">
                                                Add to Cart
                                            </Button>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))
                        ) : (
                            <Col className="d-flex justify-content-center">
                                <div className="text-center" >
                                    {/* <img
                                        src="/images/no-products.svg" // Replace with your actual path to an illustrative image
                                        alt="No Products"
                                        className="img-fluid mb-3"
                                        style={{ maxWidth: "150px" }}
                                    /> */}
                                    <h1 className="">No Products Available</h1>
                                    <p className="text-muted">
                                        We couldn't find any products matching your search or in this category right now.
                                        Please try browsing other categories or refine your search criteria.
                                    </p>
                                </div>
                            </Col>
                        )}
                    </Row>

                )}

                {filteredProducts.length > productsPerPage && (
                    <div className="pagination-container d-flex justify-content-center">
                        <ul className="pagination">
                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => paginate(currentPage - 1)}>&laquo;</button>
                            </li>
                            {[...Array(totalPages)].map((_, index) => (
                                <li
                                    key={index}
                                    className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                                >
                                    <button className="page-link" onClick={() => paginate(index + 1)}>
                                        {index + 1}
                                    </button>
                                </li>
                            ))}
                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                <button className="page-link" onClick={() => paginate(currentPage + 1)}>&raquo;</button>
                            </li>
                        </ul>
                    </div>
                )}
            </div>
        </>
    );
};

export default ShopPage;
